import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { useState, useEffect } from 'react';
import styled from 'styled-components';
import { colors } from '@/theme/colors';
const MessageContainer = styled.div `
  position: fixed;
  top: 20px;
  left: 50%;
  transform: translateX(-50%);
  z-index: 1000;
  pointer-events: none;
`;
const MessageItem = styled.div `
  background: ${({ type }) => {
    switch (type) {
        case 'success': return colors.success;
        case 'error': return colors.error;
        case 'warning': return colors.warning;
        case 'info': return colors.info;
        default: return colors.primary;
    }
}};
  color: ${colors.textWhite};
  padding: 12px 24px;
  border-radius: 8px;
  margin-bottom: 8px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  font-size: 14px;
  font-weight: 500;
  opacity: ${({ visible }) => visible ? 1 : 0};
  transform: ${({ visible }) => visible ? 'translateY(0)' : 'translateY(-20px)'};
  transition: all 0.3s ease;
  pointer-events: auto;
  cursor: pointer;
  
  &:hover {
    transform: translateY(-2px);
    box-shadow: 0 6px 16px rgba(0, 0, 0, 0.2);
  }
`;
let messageInstance = null;
export const Message = ({ type, content, duration = 3, onClose, }) => {
    const [visible, setVisible] = useState(true);
    useEffect(() => {
        const timer = setTimeout(() => {
            setVisible(false);
            setTimeout(() => {
                onClose?.();
            }, 300);
        }, duration * 1000);
        return () => clearTimeout(timer);
    }, [duration, onClose]);
    const handleClick = () => {
        setVisible(false);
        setTimeout(() => {
            onClose?.();
        }, 300);
    };
    return (_jsx(MessageItem, { type: type, visible: visible, onClick: handleClick, children: content }));
};
export const message = {
    success: (content, duration = 3) => {
        // Временная заглушка - в реальном приложении здесь будет логика показа сообщений
        console.log('Success:', content);
    },
    error: (content, duration = 3) => {
        console.log('Error:', content);
    },
    warning: (content, duration = 3) => {
        console.log('Warning:', content);
    },
    info: (content, duration = 3) => {
        console.log('Info:', content);
    },
};
// Создаем глобальный контейнер для сообщений
export const MessageProvider = ({ children }) => {
    const [messages, setMessages] = useState([]);
    const addMessage = (type, content, duration) => {
        const id = Math.random().toString(36).substr(2, 9);
        setMessages(prev => [...prev, { id, type, content, duration }]);
    };
    const removeMessage = (id) => {
        setMessages(prev => prev.filter(msg => msg.id !== id));
    };
    useEffect(() => {
        messageInstance = {
            success: (content, duration = 3) => addMessage('success', content, duration),
            error: (content, duration = 3) => addMessage('error', content, duration),
            warning: (content, duration = 3) => addMessage('warning', content, duration),
            info: (content, duration = 3) => addMessage('info', content, duration),
        };
    }, []);
    return (_jsxs(_Fragment, { children: [children, _jsx(MessageContainer, { children: messages.map(({ id, type, content, duration }) => (_jsx(Message, { type: type, content: content, duration: duration, onClose: () => removeMessage(id) }, id))) })] }));
};
